export default {
  employees: [],
};
